import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import PresentationCheckboxes from "./components/PresentationCheckboxes";
import PresentationDropdown from "./components/PresentationDropdown";
import PresentationHeatMap from "./components/PresentationHeatMap";

class Multi extends Component {

  constructor(props) {
    super(props);

    this.isAnswerDisabled = this.isAnswerDisabled.bind(this);
    this.handlerDetailsUpdated = this.handlerDetailsUpdated.bind(this);
  }

  handlerDetailsUpdated(details){
    this.props.onDetailsUpdated(details);
  }

  isAnswerDisabled(answerId){
    let isDisabled = false;
    const {details} = this.props;
    const {answers, answersMax} = this.props.question;

    if(answersMax > 0){
      const maxAnswersReached = answersMax > 0 && details.length >= answersMax;
      const isSelected = details.filter(detail => parseInt(detail.answer) === parseInt(answerId)).length > 0;
      if(!isSelected && maxAnswersReached){
        isDisabled = true;
      }
    }

    //check is selected any blocking answer
    if(details.filter(detail => parseInt(detail.answer) !== parseInt(answerId) && answers.find(a => a.id === parseInt(detail.answer)).blocking).length > 0){
      isDisabled = true;
    }

    return isDisabled;
  }

  presentationType(){
    const {details, question} = this.props;
    const {answers, answersColumns, answersImage, presentationType, answerOpenAlwaysShow} = this.props.question;

    const defaultProps = {
      question,
      answersImage,
      details,
      answers,
      answersColumns,
      isAnswerDisabled: this.isAnswerDisabled,
      onDetailsUpdated: this.handlerDetailsUpdated,
    };

    switch (presentationType) {
      case 'checkboxes':
        return <PresentationCheckboxes
          answerOpenAlwaysShow={answerOpenAlwaysShow}
          {...defaultProps}
        />;
      case 'dropdown':
        return <PresentationDropdown
          {...defaultProps}
          isSearchable={false}
        />;
      case 'dropdownFilter':
        return <PresentationDropdown
          {...defaultProps}
          isSearchable={true}
        />;
      case 'heatMap':
        return <PresentationHeatMap
          heatMapBg={question.heatMapBg}
          {...defaultProps}
        />;
    }
  }

  validate(){
    const {details, validationTexts} = this.props;
    const {answers, required} = this.props.question;
    let {answersMin} = this.props.question;

    if(answersMin > 0 && answersMin > this.props.question.answers.length){
      answersMin = this.props.question.answers.length;
    }

    let validate = {
      valid: true,
      errors: []
    };

    if(required && !answersMin && _.isEmpty(details)){
      validate.errors.push(validationTexts.required);
    }

    if (details.length < answersMin) {
      if (required || (!required && details.length > 0)) {
        validate.errors.push(validationTexts.requiredMinimumAnswers);
      }
    }

    if (!_.isEmpty(details)) {
      _.each(details, detail => {
        const answer = answers.find(ans => ans.id === parseInt(detail.answer));
        const content = detail.content;

        if (answer.isOpen && _.isEmpty(content) && !answer.openIsNotRequired) {
          if (validate.errors.indexOf(validationTexts.detail.answerContentEmpty) === -1){
            validate.errors.push(validationTexts.detail.answerContentEmpty);
          }
        }
      });
    }

    validate.valid = _.isEmpty(validate.errors);
    return validate;
  }

  render() {
    return this.presentationType();
  }
}

Multi.propTypes = {
  question: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
      isOpen: PropTypes.bool.isRequired,
      blocking: PropTypes.bool.isRequired,
      openIsNotRequired: PropTypes.bool.isRequired,
    }),).isRequired,
    answersColumns: PropTypes.number.isRequired,
    answersImage: PropTypes.bool.isRequired,
    answersMin: PropTypes.number.isRequired,
    answersMax: PropTypes.number.isRequired,
    presentationType: PropTypes.oneOf(['checkboxes', 'dropdown', 'dropdownFilter', 'heatMap']).isRequired,
    required: PropTypes.bool.isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    answer: PropTypes.number.isRequired,
    content: PropTypes.string,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.shape({
    exceededMaxAnswers: PropTypes.string.isRequired,
    requiredMinimumAnswers: PropTypes.string.isRequired,
    required: PropTypes.string.isRequired,
    detail: PropTypes.shape({
      answerContentEmpty: PropTypes.string.isRequired,
      answerContentShouldBeEmpty: PropTypes.string.isRequired,
      answerEmpty: PropTypes.string.isRequired,
      answerWrong: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
};

export default connect(null, null, null, {withRef: true, forwardRef: true})(Multi);